import React from 'react';
import { View, TouchableOpacity, Text } from 'react-native';
import i18n from 'i18n-js';

import { useManageAlertButton } from '@components/alert/hooks/useManageAlertButton';
import { AlertButtonProps } from '@components/alert/types';

export const AlertButton = ({ index, b, C, btnBorder, bntWidth, rounding, getFont, getColor, isHorizontal, hide }: AlertButtonProps) => {
  const { ref, scale, hovered, pressed, handlePress, handlePressIn, handlePressOut } = useManageAlertButton({ b, hide });

  return (
    <View
      style={[
        {
          width: bntWidth,
        },
        index !== 0 && btnBorder,
      ]}
    >
      <TouchableOpacity
        ref={ref}
        testID={b.testID}
        onPress={handlePress}
        style={[
          rounding(index),
          hovered && {
            backgroundColor: C('Button/Light/Only Text hover'),
          },
          pressed && {
            backgroundColor: C('Button/Light/Only Text pressed'),
          },
          {
            width: '100%',
            paddingTop: scale(isHorizontal ? 9 : 11),
            paddingBottom: scale(11),
            justifyContent: 'center',
            alignItems: 'center',
            alignContent: 'center',
          },
        ]}
        onPressIn={handlePressIn}
        onPressOut={handlePressOut}
        activeOpacity={1}
      >
        <Text style={[getFont(b.style), { color: C(getColor(b.style)) }]}>{i18n.t(b.text)}</Text>
      </TouchableOpacity>
    </View>
  );
};
